import * as React from "react";
import { useGetCart } from "../../../../hooks/hooks/use-get-cart.js";
import { CartContext } from "./context.js";
const CartProvider = ({ children, ...rest }) => {
  const {
    cartCount,
    cartHash,
    cartId,
    onUnrecoverableErrors,
    onUpdateCartLocaleState,
    onFinalisedCartError,
    onCartDataLoadedSuccessfully
  } = rest;
  const { called, refetch, loading, data, error, fetchByCartId } = useGetCart({
    cartCount,
    cartHash,
    cartId,
    onUnrecoverableErrors,
    onUpdateCartLocaleState,
    onFinalisedCartError,
    onCartDataLoadedSuccessfully
  });
  const value = React.useMemo(
    () => ({ cart: data, refetch, loading, error, called, fetchByCartId }),
    [data, refetch, called, loading, error, fetchByCartId]
  );
  if (typeof children === "function") {
    return /* @__PURE__ */ React.createElement(CartContext.Provider, { value }, children(value));
  }
  return /* @__PURE__ */ React.createElement(CartContext.Provider, { value }, children);
};
export {
  CartProvider
};
//# sourceMappingURL=provider.js.map
